package com.wintermar.inspection.feature.util.finding_category

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.graphql.type.FindingCategory

@Composable
fun FindingCategoryView(
    category: FindingCategory,
    bold: Boolean = true,
    showDescription: Boolean = true,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    val variant = category.toVariant()

    Column(
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space1
        )
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(
                space = dimension.spacing.space1
            ),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier
                    .size(dimension.spacing.space2)
                    .background(
                        shape = RoundedCornerShape(dimension.radius.full),
                        color = variant.color
                    ),
            ) {}

            TextBodySmall(
                text = variant.label,
                bold = bold
            )
        }
        if (showDescription) {
            TextBodySmall(
                text = variant.description,
                color = { it.subtle }
            )
        }
    }
}
